// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__TCfxu","subheader":"ReorderModal_subheader__2JWF8","listWrap":"ReorderModal_listWrap__1c14D"};